const getThumbnailUrl = (name, path) => {
  const imagePath = "/" + path + "/" + name;
  return "https://bilder.anneandersen.no/resize.php?src=" + encodeURIComponent(imagePath) + "&width=2000";
};

const getFullSizeUrl = (name, path) => {
  return "https://bilder.anneandersen.no/" + path + "/" + name;
};

export { getThumbnailUrl, getFullSizeUrl };
